import { useState } from 'react'
import type { FormEvent } from 'react'

const submitAddr = 'https://readdy.ai/api/form/daio0ojp14a1h3mr77tg'

const interests = ['影视圈', '综艺', '科技圈', '体育赛场', '城市民生', '都不挑，全都要蹲']

type Status = 'idle' | 'loading' | 'success' | 'error'

export default function SubscribeSection() {
  const [status, setStatus] = useState<Status>('idle')
  const [message, setMessage] = useState('')

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)

    const honeypot = String(formData.get('website_alt') || '').trim()
    if (honeypot) {
      setStatus('success')
      setMessage('订阅成功，新后续出来会先告诉你。')
      form.reset()
      return
    }
    formData.delete('website_alt')

    const body = new URLSearchParams()
    formData.forEach((value, key) => {
      body.append(key, String(value))
    })

    setStatus('loading')
    setMessage('')

    try {
      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
      const responseText = await response.text()
      let parsed: {
        code?: string
        message?: string
        meta?: { message?: string; detail?: string }
      } | null = null
      try {
        parsed = JSON.parse(responseText)
      } catch {
        parsed = null
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success')
        setMessage('订阅成功，新后续出来会先告诉你。')
        form.reset()
      } else {
        setStatus('error')
        setMessage(isSpam ? '提交未通过校验，请稍后再试一次。' : serverMsg || '提交失败，请稍后再试。')
      }
    } catch {
      setStatus('error')
      setMessage('网络好像不太顺，稍后再试一次吧。')
    }
  }

  return (
    <section id="subscribe" className="border-b border-background-200/80 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200/80 bg-background-100/60 lg:grid-cols-[1fr_1fr]">
          <div className="border-b border-background-200/80 p-6 md:p-9 lg:border-b-0 lg:border-r">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1">
              <i className="ri-notification-3-line text-sm text-primary-600"></i>
              <span className="font-label text-xs font-medium text-primary-700">蹲守订阅</span>
            </div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px]">
              蹲一个后续，
              <br className="hidden sm:block" />
              有新进展先告诉你
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              留下邮箱和你在蹲的方向，我们会在话题出现新进展时，把更新流里的关键一条发给你。不催更、不灌水，只发真的有后续的那几条。
            </p>
            <ul className="mt-6 space-y-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-base text-accent-600"></i>
                只在关键节点提醒，不看热闹不打扰
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-base text-accent-600"></i>
                可随时退出，不做二次收集
              </li>
            </ul>
          </div>

          <div className="p-6 md:p-9">
            <form data-readdy-form id="subscribe-51cg-form" action={submitAddr} method="post" onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="sub-email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  邮箱
                </label>
                <input
                  id="sub-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="you@example.com"
                  className="w-full rounded-md border border-background-300/80 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                />
              </div>

              <div>
                <label htmlFor="sub-interest" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  在蹲的方向
                </label>
                <div className="relative">
                  <select
                    id="sub-interest"
                    name="interest"
                    defaultValue={interests[0]}
                    className="w-full appearance-none rounded-md border border-background-300/80 bg-background-50 px-4 py-3 pr-10 text-sm text-foreground-900 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                  >
                    {interests.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  <i className="ri-arrow-down-s-line pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
                </div>
              </div>

              <div>
                <label htmlFor="sub-note" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  想蹲的话题（选填）
                </label>
                <textarea
                  id="sub-note"
                  name="note"
                  rows={2}
                  maxLength={500}
                  placeholder="比如：某个正在更新的剧情线、你追的合集编号……"
                  className="w-full resize-none rounded-md border border-background-300/80 bg-background-50 px-4 py-3 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-100"
                />
              </div>

              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-address-field"
              />

              <button
                type="submit"
                disabled={status === 'loading'}
                className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70 cursor-pointer"
              >
                {status === 'loading' ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-base"></i>
                    正在提交
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line text-base"></i>
                    帮我蹲着
                  </>
                )}
              </button>

              {status === 'success' && (
                <p className="flex items-center gap-2 rounded-md bg-accent-50 px-3 py-2 text-sm text-accent-800">
                  <i className="ri-checkbox-circle-line text-base"></i>
                  {message}
                </p>
              )}
              {status === 'error' && (
                <p className="flex items-center gap-2 rounded-md bg-primary-50 px-3 py-2 text-sm text-primary-700">
                  <i className="ri-error-warning-line text-base"></i>
                  {message}
                </p>
              )}
              <p className="text-xs leading-relaxed text-foreground-500">
                提交即表示你同意我们仅用该邮箱发送后续更新提醒，不会用于其他用途。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}